import {Button} from 'components/system/Button'
import {ReactComponent as InfoCircleIcon} from 'icons/info-circle.svg'

type Props = {
  onClick: () => void
}

export const TourDetailsButton = ({onClick}: Props) => {
  return (
    <Button className="flex items-center text-french-blue-040 gap-1 h-[40px]" onClick={onClick}>
      <InfoCircleIcon />
      <span>Tour Details</span>
    </Button>
  )
}
